import { Checkbox, Input, DatePicker, Select, Option, CheckboxGroup, CheckboxButton, Popover, Button } from 'element-ui';
import VueTimepicker from 'vue2-timepicker'
import ResourceSvc from '@/services/resource.svc.js';
const Request = new ResourceSvc();
import RaceDetails from '@/components/user/race-events/race-entry/race-details/race-details.vue';
import Tbanner from '@/components/user/race-events/race-components/web-banner-2022.vue';
import 'vue2-timepicker/dist/VueTimepicker.css';

export default {
    name: 'RaceEntry',
    components: {
        'race-details': RaceDetails,
        [VueTimepicker.name]: VueTimepicker,
        [Checkbox.name]: Checkbox,
        [Input.name]: Input,
        [Select.name]: Select,
        [Option.name]: Option,
        [DatePicker.name]: DatePicker,
        [CheckboxButton.name]: CheckboxButton,
        [CheckboxGroup.name]: CheckboxGroup,
        [Popover.name]: Popover,
        [Button.name]: Button,
        't-banner': Tbanner
    },
    data() {
        return {
            userCookies: null,
            isProcessing: false,
            isError: true,
            isRegisteredAll: false,
            environmentProperties: [],
            environmentPropertiesForUser: [],
            environmentEventsForUser: [],
            saveRaceOdmResult: [],
            raceDetails: [],
            odlSessionItem: [],
            proceedToPaymentOdlCMSresult: [],
            selectedRegisterType: null,
            selectedAthlet: null,
            isShowPaymentButton: false,
            successMessage: '',
            isExistOdl: false,
            isShowAllOdls: false,
            isAcceptedTerms: false,
            selectedODMs: [],
            isHideOdlRequest: false,
            isDisabled: false,
        }
    },
    watch: {
    },
    computed: {
        userIdUrl() {//this case when we register junior account for odl
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);
            return params.get("userId");
        },
        raceIdUrl() {//this one when need to show is odl avalible
            let uri = window.location.search.substring(1);
            let params = new URLSearchParams(uri);
            return params.get("rId");
        }
    },
    methods: {
        json_parser(input, propName) {//get *new Date* from response and do valid
            const r = /new Date+[(]\d*[\,]{1}\d*[\,]\d*[\,]\d*[\,]\d*[\,]\d*[)]/;
            var match = input.match(r);
            if (match && match[0]) {
                let dateMatch = match[0].match(/\d*[\,]{1}\d*[\,]\d*[\,]\d*[\,]\d*[\,]\d*/);
                let dateSplit = dateMatch[0].split(',');
                let dateReplace = new Date(dateSplit[0], dateSplit[1], dateSplit[2], dateSplit[3], dateSplit[4], dateSplit[5]);
                let jsonDate = JSON.stringify(dateReplace);
                let result = input.replace(match[0], jsonDate);

                this.json_parser(result, propName);//recursion
            }
            else {
                switch (propName) {
                    case 1:
                        this.environmentProperties = JSON.parse(input);
                        break;
                    case 2:
                        this.environmentPropertiesForUser = JSON.parse(input);
                        break;
                    case 3:
                        this.juniorAccountList = JSON.parse(input);
                        break;
                    case 4:
                        this.saveRaceOdmResult = JSON.parse(input);
                        break;
                    case 5:
                        this.proceedToPaymentOdlCMSresult = JSON.parse(input);
                        break;
                }
                return;
            }
        },
        loadEnvironmentProperties() {//general api from old app - output: checked user for login..
            var self = this;
            Request.getEnvironmentProperties({ json: `` }, self.cookiesValue)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.d) {
                        self.json_parser(response.body.d, 1);
                    } else {
                        self.$showError("Something went wrong. Contact with DEV team!");
                    }
                },
                    () => {
                        self.isProcessing = false;
                        self.$showError("Something went wrong. Contact with DEV team!");
                    });
        },
        loadEnvironmentForUser() {//get all valid odl's by race id or for user id
            var self = this;
            Request.getEnvironmentForUser({ json: self.userIdUrl && self.userIdUrl.length ? `${self.userIdUrl}` : `` }, self.userCookies)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.d) {
                        self.json_parser(response.body.d, 2);
                        if (self.environmentPropertiesForUser.Message == 'Your session has expired. Please login or reload the current page.') {
                            window.location.href = process.env.url.oldApp + `/login.aspx?ReturnUrl=` + window.location.href;
                        }
                        if (self.environmentPropertiesForUser && self.environmentPropertiesForUser.ResponseStatus == 1) {
                            self.isExistOdl = true;
                            if (self.raceIdUrl && self.raceIdUrl.length) {
                                const index = self.environmentPropertiesForUser.CustomObject.Events.findIndex(x => x.Id == self.raceIdUrl);//finding by urlId event in array odls
                                if (index > -1) {
                                    self.environmentEventsForUser = self.environmentPropertiesForUser.CustomObject.Events[index];
                                } else {
                                    self.isHideOdlRequest = true;
                                    self.isShowAllOdls = true;
                                    this.saveOdmItem();
                                }
                            } else {
                                self.environmentEventsForUser = self.environmentPropertiesForUser.CustomObject.Events.filter(s => s.SystemFormAccess == "No");
                                self.isShowAllOdls = true;
                            }
                        }
                    } else {
                        self.$showError("Something went wrong. Contact with DEV team!");
                    }
                },
                    () => {
                        self.isProcessing = false;
                        self.$showError("Something went wrong. Contact with DEV team!");
                    });
        },
        addODMForExternalRace() {
            var self = this;
            Request.addODMForExternalRace({ json: `${this.raceIdUrl}` }, self.userCookies)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.d) {
                        self.json_parser(response.body.d, 2);
                    } else {
                        self.isDisabled = false;
                        self.$showError("Something went wrong. Contact with DEV team!");
                    }
                },
                    () => {
                        self.isProcessing = false;
                        self.isDisabled = false;
                        self.$showError("Something went wrong. Contact with DEV team!");
                    });
        },
        getOdlSessionItem(guid) {
            var self = this;
            Request.getOdlSessionItem({ json: `${guid}` }, self.userCookies)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.d && JSON.parse(response.body.d) && JSON.parse(response.body.d).ResponseStatus == 1) {
                        self.odlSessionItem = response.body.d;
                    } else {
                        self.$showError("Something went wrong. Contact with DEV team!");
                    }
                },
                    () => {
                        self.isProcessing = false;
                        self.$showError("Something went wrong. Contact with DEV team!");
                    });
        },
        getDetailsConfirmedCMS(guid) {
            var self = this;
            Request.getDetailsConfirmed(guid, self.userCookies)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.d && JSON.parse(response.body.d) && JSON.parse(response.body.d).ResponseStatus == 1) {
                        self.getDetailsConfirmedResult = JSON.parse(response.body.d);
                    } else {
                        self.$showError("Something went wrong. Contact with DEV team!");
                    }
                },
                    () => {
                        self.isProcessing = false;
                        self.$showError("Something went wrong. Contact with DEV team!");
                    });
        },
        loadRaceInfo(rId) {
            let self = this;
            let raceId;
            if (!rId) {
                raceId = this.raceIdUrl && this.raceIdUrl != null ? this.raceIdUrl : null;
            } else {
                raceId = rId;
            }
            if (raceId && raceId != null) {
                self.raceDetails = [];
                self.isProcessing = true;
                Request.raceCalendarCardInfo(raceId)
                    .then(res => {
                        if (res && res.body && res.body.isSuccess) {
                            self.raceDetails = res.body.outputData[0];
                            self.isProcessing = false;
                        }
                        else {
                            self.$showError(res && res.body && res.body.message ? res.body.message : null, 5000);
                        }
                    },
                        err => {
                            self.isProcessing = false;
                            self.$showError(5000);
                        });
            }
        },
        async loadCookies() {
            let self = this;
            await Request.getCookies()
                .then(res => {
                    if (res && res.body && res.ok) {
                        self.userCookies = res.body;
                    }
                    else {
                        window.location.href = process.env.url.oldApp + `/login.aspx?ReturnUrl=` + window.location.href;
                    }
                },
                    err => {
                        self.$showError(5000);
                    });
        },
        proceedToPaymentOdlCMS(guid) {
            var self = this;
            let rIds;
            let tmp_rids = [];
            if (self.raceIdUrl && self.raceIdUrl.length) {
                rIds = "\"" + self.raceIdUrl + "\"";
            } else if (self.selectedODMs && self.selectedODMs.length > 0) {
                for (let i = 0; i < self.selectedODMs.length; i++) {
                    tmp_rids[i] = "\"" + self.selectedODMs[i] + "\"";
                }
                rIds = tmp_rids.join(", ");
                if (!self.isAcceptedTerms) { return; }
            } else { return; }

            let requestHeader = { json: null };
            requestHeader.json = `{"Guid": "${guid}", "EventIds": [${rIds}], "CreateDateTime": null}`;
            Request.proceedToPaymentOdlCMS(requestHeader, self.userCookies)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.d) {
                        self.json_parser(response.body.d, 5);
                        if (this.proceedToPaymentOdlCMSresult.ResponseStatus == 1) {
                            window.location.href = process.env.url.oldApp + "/membership/PaymentDetails.aspx";
                        }
                    } else {
                        window.location.href = process.env.url.oldApp + `/login.aspx?ReturnUrl=` + window.location.href;
                    }
                },
                    () => {
                        self.isProcessing = false;
                        self.$showError("Something went wrong. Contact with DEV team!");
                    });
        },
        saveOdmItem() {
            var self = this;
            let rIds;
            let tmp_rids = [];
            if (self.raceIdUrl && self.raceIdUrl.length) {
                rIds = "\"" + self.raceIdUrl + "\"";
            } else if (self.selectedODMs && self.selectedODMs.length > 0) {
                for (let i = 0; i < self.selectedODMs.length; i++) {
                    tmp_rids[i] = "\"" + self.selectedODMs[i] + "\"";
                }
                rIds = tmp_rids.join(", ");
            } else { return; }

            let requestHeader = { json: null };
            requestHeader.json = `{"EventIds": [${rIds}], "PurchaseDate": null, "UserId": ${self.userIdUrl && self.userIdUrl ? self.userIdUrl : self.environmentProperties.CustomObject.User.Id}, "CreateDateTime": null, "id": null}`;
            Request.saveOdmItem(requestHeader, self.userCookies)
                .then(response => {
                    self.isProcessing = false;
                    if (response && response.body && response.body.d && JSON.parse(response.body.d) && JSON.parse(response.body.d).ResponseStatus == 1) {
                        self.json_parser(response.body.d, 4);
                        self.isShowPaymentButton = true;
                        if (self.selectedODMs && self.selectedODMs.length) {//rerender selected races
                            self.$showSuccess("THE DETAILS HAVE BEEN SAVED.");
                            self.environmentEventsForUser = self.environmentPropertiesForUser.CustomObject.Events
                                                                .filter((x) => self.selectedODMs.includes(x.Id));
                        }
                    } else {
                        self.$showError("Something went wrong. Contact with DEV team!");
                    }
                },
                    () => {
                        self.isProcessing = false;
                        self.$showError("Something went wrong. Contact with DEV team!");
                    });
        },
        async confirmRegistration() {
            let self = this;
            self.isDisabled = true;
            await self.addODMForExternalRace();
        },
        async buyOdm() {
            if (this.isAcceptedTerms) {
                await this.saveOdmItem();
            }
        },
        async proceedToPayment() {
            if (this.saveRaceOdmResult && this.saveRaceOdmResult.CustomObject && this.saveRaceOdmResult.CustomObject.length && this.isAcceptedTerms) {
                await this.getOdlSessionItem(this.saveRaceOdmResult.CustomObject);
                await this.proceedToPaymentOdlCMS(this.saveRaceOdmResult.CustomObject);
            }
        },
        isExistOdlByRaceId() {
            let self = this;
            if (self.environmentPropertiesForUser && self.environmentPropertiesForUser.ResponseStatus == 1) {
                const index = self.environmentPropertiesForUser.CustomObject.Events.findIndex(x => x.Id == self.raceIdUrl);
                if (index > -1) {
                    self.environmentEventsByRaceId = self.environmentPropertiesForUser.CustomObject.Events[index];
                    self.isExistOdl = true;
                }
            }
        }
    },
    async created() {
        await this.loadCookies();
        await this.loadEnvironmentProperties();
        await this.loadEnvironmentForUser();
        await this.isExistOdlByRaceId();
        await this.loadRaceInfo();
    }
}



// WEBPACK FOOTER //
// ./src/components/user/race-events/race-odl/layout.js